module.exports = __webpack_public_path__ + "static/media/small-white-clubs.abdca3cc.svg";